import { render, staticRenderFns } from "./userLevelEdit.vue?vue&type=template&id=30161a90&scoped=true&"
import script from "./userLevelEdit.vue?vue&type=script&lang=js&"
export * from "./userLevelEdit.vue?vue&type=script&lang=js&"
import style0 from "./userLevelEdit.vue?vue&type=style&index=0&id=30161a90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30161a90",
  null
  
)

export default component.exports